import { render, staticRenderFns } from "./DadosAcesso.vue?vue&type=template&id=2f32e2d2"
import script from "./DadosAcesso.vue?vue&type=script&lang=js"
export * from "./DadosAcesso.vue?vue&type=script&lang=js"
import style0 from "./DadosAcesso.vue?vue&type=style&index=0&id=2f32e2d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports